import React, { FC } from 'react';
import { StyledButton } from './Button.styled';
import { ButtonProps } from './Button.types';

export const Button: FC<ButtonProps> = ({ children, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <StyledButton {...rest}>{children}</StyledButton>
);
